import { orchestrator } from 'satcheljs';
import { getOWAConnectedAccounts } from 'owa-accounts-store';
import { setMergedViewEnabledAccount } from '../mutators/setMergedViewEnabledAccountMutatorActions';
import { getTimeProfileService, TimeProfileInformation } from 'owa-timeprofile-service';
import { initializeTrueTimeStore, trueTimeStoreInitialized } from '../actions/publicActions';
import { getStoreState } from '../selectors/getStoreState';
import { setStoreState } from '../mutators/setStoreStateMutatorAction';
import { State } from '../store/schema/State';
import { trace } from 'owa-trace';

orchestrator(initializeTrueTimeStore, async () => {
    const storeState = getStoreState();

    if (storeState == State.Uninitialized || storeState == State.Error) {
        let newStoreState = State.Error;
        let primarySmtpAddress = undefined;

        // initialize merged view enabled state from service call
        let timeProfileInformation: TimeProfileInformation = await getTimeProfileService();
        if (timeProfileInformation) {
            newStoreState = State.Initialized;

            primarySmtpAddress = timeProfileInformation.MergedViewEnabled
                ? timeProfileInformation.ConsumerEmailAddress
                : null;
        } else {
            trace.warn('initializeTrueTimeStore failed to get TimeProfileInformation');
        }

        if (primarySmtpAddress) {
            getOWAConnectedAccounts().map(account => {
                if (
                    account.accountProviderType == 'Google' &&
                    account.anchorMailbox == primarySmtpAddress
                ) {
                    primarySmtpAddress = account.displayEmail;
                }
            });
        }

        setMergedViewEnabledAccount(primarySmtpAddress);
        setStoreState(newStoreState);
        trueTimeStoreInitialized();
    }
});
